<!-- 

This component is used to upload items to our servers, and add the upload as an entry
in the "documents" table in our main database. "Documents" is a catch-all term that 
can be used for pdf's, images, etc.

This component is aimed at backend, admin users. If the need arises for a public
facing upload component, make a new version, based off this version, with
increased security. Check upload sizes, file types, etc.

Example usage:

<up-loader
  v-on:updateloaders="someFunction" 
  :document-id="docId" 
  :note-id="noteId">
</up-loader>

Since we're dynamically creating these upload names and locations, the document Id and note Id
are almost always going to be dynamic. Using the MultiUploader component (which uses this as a child)
instead of this component will be the easiest way to handle this.

 -->
<template>
  <div class="row">
    <div class="col-4 no-padding ml-3">
      <input type="text" v-model="documentName" placeholder="File Name" class="form-control" />
    </div>

    <div class="col-6">
      <a :href="documentLink" target="blank" class="text-regular">{{fileName}}</a>
    </div>

    <div class="col-auto">
      <button @click="uploadDocument" class="btn btn-primary">
        UPLOAD
      </button>
    </div>

    <div class="col-md-4 filebutton p-3 link-cursor">
      <input type="file" ref="fileupload" :name="documentId" :id="documentId" class="form-control-file" @change="documentChange" />
    </div>

  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      documentName: "",
      documents: [],
      docUploaded: false,
      fileName: "",
      fileLocation: "",
      fileData: null,
      fileId: ""
    }
  },
  props: {
      documentId: {
      type: Number,
      default: 0
      },
      noteId: {
      type: Number,
      default: 0
      }
  },
  computed: {
    documentLink: function() {
      return this.$helpers.staticDocs() + this.fileLocation + '/' + this.fileName
    }
  },
  mounted: function() {
    //load document info if it's passed in
    this.loadDocument()
  },
  methods: {
    loadDocument: function() {
      let local = this

      //make sure id is set before attempting to load
      if (this.documentId === 0) {
        return
      } 

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/document/id/' + local.documentId,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (res) {
          //create an editor for each note
          local.docUploaded = true
          local.documentName = res.data.title
          local.fileName = res.data.filename
          local.fileLocation = res.data.location
        })
        .catch(function (error) {
          console.log("error geting document data: ", error)
      });
    },

    documentChange: function(event) {
      if (!event.target.files) {
        return
      }

      if (!this.checkFileNameLength(event.target.files[0].name)) {
        this.fileName = ""
        this.showToast('Filename too long')
        return
      }

      //remove link formatting from filname
      this.docUploaded = false

      //set file location on client system
      this.fileLocation = event.target.files[0]

      //set file name on screen
      //this.fileName = event.target.files[0].name
    },

    checkFileNameLength: function(text) {
      //filenames cannot be longer than 256
      let dateLen = 8
      let textLen = text.length
      let total = textLen + dateLen
      
      if (total > 200) {
        return false
      }

      return true
    },

    packageData: function() {
      if (this.fileLocation == "") {
        this.showToast('Please choose file')
      }

      const formData = new FormData()
      formData.append("file", this.fileLocation)
      formData.append("title", this.documentName)
      formData.append("noteid", this.noteId)
      formData.append("documentid", this.documentId)
      this.fileData = formData
    },

    uploadDocument: function() {
      //pack up data for request
      this.packageData()

      if (this.documentId === 0) {
        this.createDocument()
      } else {
        this.updateDocument()
      }

      //clear file upload data no matter what
      this.clearUploadInput()
    },

    createDocument: function() {
      //set local
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/document/create',
          data: local.fileData,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data',
                    'User-Token': local.$helpers.getToken()} //only needed for admin tasks
        })
        .then(function (res) {
          local.savedDocumentData() //notify user of save
          local.$emit('updateloaders')
          local.loadDocument() //reload data
        })
        .catch(function (error) {
          //upload failed, do a popup
        });
    },

    updateDocument: function() {
      //set local
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/document/update',
          data: local.fileData,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data',
                    'User-Token': local.$helpers.getToken()} //only needed for admin tasks
        })
        .then(function (res) {
          local.savedDocumentData() //notify user of save
          local.loadDocument() //reload data
        })
        .catch(function (error) {
          //upload failed, do a popup
        });    
    },

    savedDocumentData: function() {
      //clear the form
      this.documentName = ""
      this.fileName = ""
      this.showToast('Upload Successful')
    },

    clearUploadInput: function() {
      this.$refs.fileinput.value = ""
    },

    showToast: function(text) {
      //find a toast thing to show
    }
  }
}

</script>

<style>
</style>